// extracted by mini-css-extract-plugin
export default {"container":"header-module--container--YhtQ8","content":"header-module--content--jII9J","move":"header-module--move--CO17K"};